"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const QuestionsQuery = (0, graphql_tag_1.default)(`
  query questions(
    $questionVariationId: String! = ""
    $org: String! = ""
    $itemsPerPage: Int = 50
    $page: Int = 1
  ) {
    questions(
      questionRequest: {
        variationId: $questionVariationId
        org: $org
        itemsPerPage: $itemsPerPage
        page: $page
      }
    ) {
      totalQuestions
    }
  }
`);
exports.default = QuestionsQuery;
